import React from 'react';

// GLOBAL VARIABLES
import { MODAL } from 'defaults.js';
import { TIMES } from 'globals.js';

// PRIMARY TYPES
import AlertModal from './AlertModal';
import DialogModal from './DialogModal';

// SECONDARY TYPES
import ConfirmationModal from './ConfirmationModal';
import DeleteModal from './DeleteModal';
import ErrorModal from './ErrorModal';
import FormModal from './FormModal';
import SessionModal from './SessionModal';

// FUNCTIONS
const errorDuration = ({ errors = [] }) => TIMES.modalDuration * ((errors.length) + 1);

// EXPORT
export const TYPES = {
  Alert        : AlertModal,
  Error        : ({ useErrorDialog = MODAL.useErrorDialog, ...props }) => useErrorDialog ? <ErrorModal {...props} /> : <AlertModal {...props} variant="danger" duration={errorDuration(props)} />,
  Loading      : props => <AlertModal {...props} type="loading" dismissible={'false'} duration={false} />,
  Dialog       : DialogModal,
  Confirmation : ConfirmationModal,
  Delete       : DeleteModal,
  Form         : FormModal,
  Session      : SessionModal
}

// SUB COMPONENTS
